import {
  createAsyncThunk,
  createSlice,
  appLogout,
  rootReducer,
  persistReducer,
} from '@bonanza-social/toolkit/state';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import { StatusConfigService } from '../../services';
import { StatusConfigState } from './statusConfig.types';

const initialState: StatusConfigState = {
  data: undefined,
  dataState: 'idle',
};

export const fetchStatusConfig = createAsyncThunk(
  'statusConfig/fetch',
  async () => {
    const response = await StatusConfigService.getStatusConfig();
    return response;
  },
);

const statusConfig = createSlice({
  name: 'statusConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStatusConfig.pending, (state) => {
      state.dataState =
        state.dataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(fetchStatusConfig.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(fetchStatusConfig.fulfilled, (state, action) => {
      state.dataState = 'fulfilled';
      state.data = action.payload;
    });

    builder.addCase(appLogout, (state) => {
      Object.assign(state, initialState);
    });
  },
});

const persistConfig = {
  key: 'statusConfig',
  storage: AsyncStorage,
  whitelist: ['data'],
};

const persistedReducer = persistReducer(persistConfig, statusConfig.reducer);

export const withStatusConfig = rootReducer.inject({
  reducerPath: 'statusConfig',
  reducer: persistedReducer,
});

export const selectStatusConfig = withStatusConfig.selector(
  (state) => state.statusConfig.data,
);

export const selectStatusConfigDataState = withStatusConfig.selector(
  (state) => state.statusConfig.dataState,
);

declare global {
  interface LazyLoadedSlices {
    statusConfig: ReturnType<typeof persistedReducer>;
  }
}
